import React from 'react';
import { Grid, Box, Skeleton } from '@mui/material';

export const IconsSkeleton = () => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      border={(theme) => `1px solid ${theme.palette.borderColor}`}
      borderRadius='10px'
      width={28}
      height={28}
    >
      <Skeleton
        variant='rounded'
        width={20}
        height={20}
        sx={{
          borderRadius: '7px',
        }}
      />
    </Box>
  );
};

const SparkPopupHeaderSkeleton = () => {
  return (
    <Grid
      container
      justifyContent='space-between'
      alignItems='center'
      paddingLeft={3}
      paddingRight={3}
      gap={1}
    >
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        // border={(theme) => `1px solid ${theme.palette.borderColor}`}
        bgcolor='white'
        borderRadius='10px'
        width={120}
        height={120}
        sx={{ marginTop: '-44px' }}
      >
        <Skeleton
          variant='rectangular'
          width={110}
          height={110}
          sx={{
            borderRadius: '8px',
          }}
        />
      </Box>

      <Grid item container flex={1} direction='column' alignSelf='center'>
        <Skeleton
          variant='text'
          width='80%'
          height={34}
          sx={{
            mt: 1,
          }}
        />
        <Box display='flex' alignItems='center' gap={1} sx={{ width: '50%' }}>
          <Skeleton variant='text' width='60%' height={34} />
        </Box>
      </Grid>
      <Grid
        item
        container
        flex={1}
        gap={1}
        justifyContent='flex-end'
        flexWrap='nowrap'
      >
        <IconsSkeleton />
        <IconsSkeleton />
        <IconsSkeleton />
      </Grid>
    </Grid>
  );
};

export default SparkPopupHeaderSkeleton;
